document.addEventListener("DOMContentLoaded", function() {

    // swiper detail - foto nemovitosti (detail-3)
    //============================================
    (function () {
        let swiperSelector = document.querySelector('.JS-detail-3-photo-slider');
        if(typeof(swiperSelector) === 'undefined' || swiperSelector === null)
            return;

        let swiperDetail3 = new Swiper(swiperSelector, {
            lazy:  {
                loadPrevNext: true
            },
            slidesPerView: 1,
            spaceBetween: 0,
            centerInsufficientSlides: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },

            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 15
                },
                480: {
                    slidesPerView: 4,
                    spaceBetween: 20
                },
                769: {
                    slidesPerView: 3,
                    spaceBetween: 27
                }
            }
        });
    }());
});